<script>
export default {
    name: "login-socials",
    props: {
        logins: {type: Array, default: []}
    },
    computed: {
        disabled() {
            return !!this.logins.length;
        }
    },
    methods: {
        calculateLabel(id) {
            return Lang.langGet('Login with') + ' ' + id.toUpperCase();
        },
        calculateIcon(id) {
            return `/img/${id}_logo.svg`
        }
    }
}
</script>

<template>
    <div v-if="disabled">
        <div class="login-divider">
            <span>or</span>
        </div>
        <v-btn v-for="login in logins"
            :key="login"
            :href="`/auth/${login}/redirect`"
            class="auth-link btn full-width mb-1"
        >
            <img :src="calculateIcon(login)" class="mr-1" :alt="calculateLabel(login)"/>
            {{ calculateLabel(login) }}
        </v-btn>
    </div>
</template>

<style scoped>
.auth-link {
    img {
        height: 1.1em;
    }
}

.login-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 12px 0;
    color: #999;
    font-size: 0.85em;
}

.login-divider::before,
.login-divider::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #ddd;
}
</style>
